import { Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Genders } from '../../../administrative';
import { UserAvatarFileDto } from '../../file/user-avatar-file-dto';
import { IdentityVerificationStatus } from '../user-identity.dto';

export class UserIdentityPopulateAvatarDto {
  @IsString()
  @IsNotEmpty()
  firstName!: string;

  @IsString()
  @IsNotEmpty()
  lastName!: string;

  @IsDateString()
  @IsNotEmpty()
  birthDate!: string;

  @IsEnum(Genders)
  @IsNotEmpty()
  gender!: Genders;

  @ValidateNested()
  @Type(() => UserAvatarFileDto)
  @IsOptional()
  avatar?: UserAvatarFileDto;

  @IsEnum(IdentityVerificationStatus)
  @IsNotEmpty()
  verificationStatus!: IdentityVerificationStatus;
}
